import { activeLocations } from './activeEnrollmentLocations'

const getEnrollmentLocationData = () => {
  const locations = [...activeLocations]
  if (process.env.NEXT_PUBLIC_APP_ENV === 'uat') {
    locations.push({
      uid: 'AUSHQ',
      name: 'Austin HQ',
      address1: '117 West 7th St',
      address2: null as never,
      zip: '71303',
      city: 'Austin',
      state: 'TX',
      country: 'USA',
      type: 'test',
      parking: 'Parking is available in front of the retail building.',
      open: true,
      latitude: 30.2211,
      longitude: -97.6878,
      serviceTerritoryId: '0Hhcn0000001embCAA',
      lanes: [
        {
          id: '1',
          locationUid: 'AUSHQ',
          name: null as never,
          description: 'Austin HQ',
          isAccessible: true,
          accessibilityMessage: null as never,
          availability: [
            {
              days: 'Monday - Friday',
              hours: '9:10am - 1:00pm, 1:30pm - 5:00pm',
            },
          ],
        },
      ],
    })
  }

  return Promise.resolve(locations)
}

export default getEnrollmentLocationData
